"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchShakaSSAIManifest = void 0;
function getAudioAdaptionSetsFromClipCategory(periods, clips, category) {
    return clips.flatMap((clip, index) => {
        if (clip.category !== category) {
            return [];
        }
        return Array.from(periods[index].querySelectorAll("AdaptationSet[lang][mimeType^=audio/*] Representation, AdaptationSet[lang] Representation[mimeType^=audio/*]")).flatMap((e) => e.closest("AdaptationSet") || []);
    });
}
// Revert Shakas audio track normalization for periods, causing ads only languages to appear in the normal options
// See https://github.com/shaka-project/shaka-player/issues/2887#issuecomment-701594716
const patchShakaSSAIManifest = (clips = []) => (manifest) => {
    var _a, _b;
    const periods = manifest.querySelectorAll("Period");
    if (periods.length <= 1 || periods.length !== (clips === null || clips === void 0 ? void 0 : clips.length)) {
        return [];
    }
    const firstAudioLang = (_b = (_a = getAudioAdaptionSetsFromClipCategory(periods, clips, "vod")) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.getAttribute("lang");
    if (firstAudioLang) {
        getAudioAdaptionSetsFromClipCategory(periods, clips, "ad").forEach((el) => el.setAttribute("lang", firstAudioLang));
    }
};
exports.patchShakaSSAIManifest = patchShakaSSAIManifest;
//# sourceMappingURL=shakaSSAIManifestPatch.js.map